<div class="price-input-container">
  <span class="form-label">{{'edp.emarket.price.preco' | translate}}(€/MWh)</span>
  <mat-form-field class="w-100">
    <input matInput formControlName="price">
    @if (form.controls.price.errors && form.controls.price.errors.pattern) {
      <div class="pt-3 pl-3 form-label text-danger">
        {{'edp.emarket.price.introduza.numero' | translate}}
      </div>
    }
  </mat-form-field>
</div>